/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import DashboardClockInPresenter from './DashboardClockInPresenter';
import { clockInService } from '../../../api/services/clockInService';
import { useAppDispatch, useAppSelector } from '../../../infra/hooks';
import {
  canClockIn,
  clockInReducer,
  setClockInLoader,
} from '../../../infra/aggregates/clockInSlice';
import toast from 'react-hot-toast';
import { clockOutReducer } from '../../../infra/aggregates/clockOutSlice';
import DTODashboardClockIn from './DTODashboardClockIn';
import { useTranslation } from 'react-i18next';
import { convertDateToEpochUTC } from '../../helper';
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
}

interface clockInType {
  location_id: string;
  note: string;
}

const DashboardClockInController = ({
  isModalOpen,
  closeModal,
}: ModalInterface) => {
  const [empLocation, setEmpLocation] = useState([]);
  const selector = useAppSelector((state) => state);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  function callBack(data: clockInType) {
    const companyId = selector.authSlice.company_id;
    const empId = selector.authSlice.emp_id;
    let lattitude: any = '57';
    let longitude: any = '43';
    const get_time = convertDateToEpochUTC(new Date());
    const checkInTime = Math.floor(get_time / 1000);

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        lattitude = pos?.coords?.latitude;
        longitude = pos?.coords?.longitude;
        clockIn(
          empId,
          companyId,
          data.note,
          data?.location_id,
          lattitude,
          longitude,
          checkInTime,
        );
      },
      function () {
        toast.error(t('Error fetching your current location'));
      },
    );
  }

  async function clockIn(
    empId: number,
    companyId: number,
    note: string,
    location_id: string,
    latitude: any,
    longitude: any,
    checkInTime: any,
  ) {
    dispatch(setClockInLoader(true));

    await clockInService
      .check_in(
        empId,
        companyId,
        checkInTime,
        note,
        location_id,
        latitude,
        longitude,
      )
      .then((response: any) => {
        if (response) {
          dispatch(
            canClockIn({
              can_checkin: false,
              last_checkin: response?.data?.clock_in,
            }),
          );
          dispatch(clockInReducer(response?.data?.data?.clock_in));
          dispatch(clockOutReducer(response?.data?.data?.clock_out));
          toast.success(t('Checked In Successfully'));
        }
      })
      .catch((err) => {
        dispatch(setClockInLoader(false));
        toast.error(err?.error?.data?.error_message);
      });
    clockInService
      .can_checkin(empId)
      .then((res: any) => {
        if (res) {
          dispatch(
            canClockIn({
              can_checkin: res?.data?.can_checkin,
              last_checkin: res?.data?.last_checkin,
            }),
          );
          dispatch(setClockInLoader(false));
          closeModal();
        } else {
          dispatch(setClockInLoader(false));
          return;
        }
      })
      .catch((err) => {
        dispatch(setClockInLoader(false));
        console.log(err);
      });
  }
  const getEmpLocation = (data: any) => {
    setEmpLocation(data);
  };
  return (
    <div>
      <DTODashboardClockIn setcallbackempLocation={getEmpLocation} />
      <DashboardClockInPresenter
        callBackHandleClockIn={callBack}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        isLoading={selector.clockInSlice.clockIn_loder}
        EmpLocationList={empLocation}
        trans={t}
      />
    </div>
  );
};

export default DashboardClockInController;
